export default function () {
  var subMenu = window.$('nav .sub-menu')

  if (window.$(subMenu.length)) {
    subMenu.closest('li').addClass('subPar')
  }

  var megaMenu = window.$('nav .mega-menu')

  if (window.$(megaMenu.length)) {
    megaMenu.closest('li').addClass('subPar')
  }

  window.$('.subPar a').each(function () {
    window.$(this).on('click', function () {
      window.$(this).parent('.subPar').toggleClass('active')
    })
  })

  window.$("a[href='#']").on('click', function ($) {
    $.preventDefault()
  }
  )
}



// WEBPACK FOOTER //
// ./src/assets/js/mega-menu.js